import type { ReactChild } from 'react';

import { hasError } from '../../utils';
import type { UseAsyncStatus } from '../../hooks/useAsyncStatus';

import { ErrorAlert } from './ErrorAlert';

type AdminCardBodyProps = {
  children: ReactChild | undefined;
  useAsyncStatuses: UseAsyncStatus[];
  initialUseAsyncStatuses: UseAsyncStatus[];
};

export const AdminCardBody = ({
  children,
  useAsyncStatuses,
  initialUseAsyncStatuses,
}: AdminCardBodyProps) => {
  const isLoading = initialUseAsyncStatuses.find(({ status }) => status.loading);

  return (
    <>
      {useAsyncStatuses.map(({ status }) => hasError(status) && <ErrorAlert status={status} />)}
      {isLoading && 'Loading...'}
      {!isLoading && children}
    </>
  );
};
